import React from "react";
import { Box, Typography } from "@mui/material";
import { useOrganizationLabels } from "../../hooks/useOrganizationLabels";

const NoCompanyDetailFound: React.FC = () => {
  const org = useOrganizationLabels();

  return (
    <Box
      sx={{
        p: 5,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        textAlign: "center",
        height: "70vh",
        color: "black"
      }}
    >
      <Typography color="textPrimary" variant="h5" fontWeight="bold" mb={2}>
        {org.notFoundTitle}
      </Typography>
      <Typography color="text.secondary" mb={3}>
        {org.notFoundDescription}
      </Typography>
    </Box>
  );
};

export default NoCompanyDetailFound;
